module.exports = __webpack_public_path__ + "img/img10.fee48528.png";